/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Settings_Close_LabelInputs */



/**
* | output |
* | --- |
* | "Close Settings" |
*
* @param {Timing_Sync_Settings_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_settings_close_label = /** @type {((inputs?: Timing_Sync_Settings_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Settings_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer les parametres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einstellungen schließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi Impostazioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрыть настройки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar configuración")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("設定を閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेटिंग्स बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechar configurações")
	return /** @type {LocalizedString} */ ("Close Settings")
});